"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.parseOneTrustCookie = parseOneTrustCookie;
var _utils = _interopRequireDefault(require("../../utils"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ONETRUST_COOKIE = 'OptanonConsent';
var ONETRUST_FUNCTIONAL_COOKIE_GROUP = 'C0003';

/**
 * Checks for and parses the information stored in the OneTrust cookie
 *
 * @returns Whether the OneTrust cookie exists and the information stored within it
 */
function parseOneTrustCookie() {
  var cookieValue = (0, _utils.default)(ONETRUST_COOKIE, '');
  var retVal = {
    hasOneTrustCookie: !!cookieValue,
    keyValues: {},
    groups: {}
  };
  if (retVal.hasOneTrustCookie) {
    cookieValue.split('&').forEach(function (token) {
      var keyVal = token.split('=').map(function (piece) {
        return decodeURIComponent(piece);
      });
      var key = keyVal.shift();
      var value = keyVal.length ? keyVal.shift() : true;
      if (key) {
        retVal.keyValues[key] = value;
      }
    });

    // fix up groups to be cleaner
    if (typeof retVal.keyValues.groups === 'string') {
      retVal.keyValues.groups.split(',').forEach(function (group) {
        var tokens = group.split(':');
        retVal.groups[tokens[0]] = tokens[1] === '1';
      });
    }
  }
  return retVal;
}
var blockedByOneTrust = function blockedByOneTrust() {
  var overrideOneTrust = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _parseOneTrustCookie = parseOneTrustCookie(),
    hasOneTrustCookie = _parseOneTrustCookie.hasOneTrustCookie,
    oneTrustGroups = _parseOneTrustCookie.groups;

  // we are blocked by OneTrust if...
  return (
    // we're not overridden to _ignore_ OneTrust...
    !overrideOneTrust &&
    // the OneTrust cookie is not present or does not have
    // functional cookies accepted
    !(hasOneTrustCookie && oneTrustGroups[ONETRUST_FUNCTIONAL_COOKIE_GROUP] === true)
  );
};
var _default = exports.default = blockedByOneTrust;